// extracted by mini-css-extract-plugin
export var cardHeader = "_gs-1";
export var contentCard = "_gs-0";
export var headerActions = "_gs-3";
export var reorderHandle = "_gs-5";
export var titleArea = "_gs-2";
export var titleAreaWithHandle = "_gs-4";